module.exports = __webpack_public_path__ + "img/invite-member-top.42dc778b.png";